var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.995,
    height: 24.605,
    viewBox: "0 0 27.995 24.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "portfolio",
    fill: "rgba(255, 255, 255, 0.40)",
    d: "M27.18,3.281H19.739v-.82A2.463,2.463,0,0,0,17.278,0H10.717A2.463,2.463,0,0,0,8.257,2.461v.82H.82A.822.822,0,0,0,0,4.1V22.145a2.463,2.463,0,0,0,2.461,2.461H25.535A2.463,2.463,0,0,0,28,22.145V4.115a.8.8,0,0,0-.815-.834ZM9.9,2.461a.821.821,0,0,1,.82-.82h6.561a.821.821,0,0,1,.82.82v.82H9.9Zm16.14,2.461L23.49,12.562a.819.819,0,0,1-.778.561H18.1V12.3a.82.82,0,0,0-.82-.82H10.717a.82.82,0,0,0-.82.82v.82H5.283a.819.819,0,0,1-.778-.561L1.958,4.921Zm-9.579,8.2v1.64H11.537v-1.64Zm9.9,9.022a.821.821,0,0,1-.82.82H2.461a.821.821,0,0,1-.82-.82V9.155l1.309,3.926a2.457,2.457,0,0,0,2.334,1.682H9.9v.82a.82.82,0,0,0,.82.82h6.561a.82.82,0,0,0,.82-.82v-.82h4.614a2.457,2.457,0,0,0,2.334-1.682l1.309-3.926Zm0,0",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/Portfolio.5863baa6.svg";
export { ForwardRef as ReactComponent };